// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"_1NxfOo","odd":"_3-zsnJ","even":"_2Vo6hB","shareButtonIcon":"IN1hjr","copyFeedback":"_2V4yxK"};